export function normalizeDropdown(p, canonicalList) {
    if (p == null) return null;

    let value = null;
    let name = null;
    if (typeof p === 'object') {
        value = p.value ?? p.id ?? null;
        name = p.name ?? p.Name ?? null;
    } else {
        value = p;
        name = String(p);
    }

    const normalized = { id: value, value: value, name: name };

    if (Array.isArray(canonicalList)) {
        const found = canonicalList.find(it => {
        const itVal = it.value ?? it.id;
        if (itVal !== undefined &&
          itVal !== null &&
          String(itVal) === String(value)) {
          return true;
        }
        if (it.name && name && it.name === name) {
          return true;
        }
        return false;
      });
      if (found) {
        return found;
      }
    }

    return normalized;
}

export default normalizeDropdown;
